import {
  COMPARISON_OPERATORS,
  FILTER_TYPES,
} from '@witmetrics/utils/constants';
import { API } from '@/api';
import { theme } from '@/utils/theme';
import { POPPER_Z_INDEX, RECENT_LIMIT } from './constants';

export const classes = {
  wrapper: 'w-full',
  textField: 'w-full',
  paper: 'rounded-xl mt-2 shadow-card',
  list: 'max-h-[40vh] overflow-y-auto',
  recentlyViewed:
    'text-sm text-grey-8 font-medium px-4 pt-3 pb-1 dark:text-mauve-1',
  message:
    'text-grey-7 text-sm text-center py-4 place-center gap-1 dark:text-mauve-2',
  selectedField: 'relative w-full rounded-2xl transition-colors',
  selectedFieldList: 'list-none p-0 m-0',
  caret: 'text-grey-7 dark:text-mauve-2',
};

export const styles = {
  endAdornment: {
    marginRight: '-2px',
  },
  clearButton: {
    padding: '4px',
  },
  popupButton: {
    padding: '2px',
    marginRight: '-2px',
  },
  popper: (width: number | undefined) => ({
    width,
    zIndex: POPPER_Z_INDEX,
  }),
  // Reads the CSS custom properties written by MAX_SIZE_MODIFIER in constants.ts.
  paper: {
    maxHeight: 'var(--paper-max-h)',
    maxWidth: 'var(--paper-max-w)',
    overflow: 'auto',
  },
  // eslint-disable-next-line witmetrics/no-multiline-comments
  /* Mirrors MUI's outlined-input border treatment: a low-opacity black
    default (MUI itself hardcodes 0.23 in OutlinedInput's source — not in
    the palette) that transitions to the codebase's orange-2 on hover.
   */
  selectedField: {
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    '&:hover': {
      borderColor: theme.palette['orange-2'].main,
    },
  },
};

export async function fetchRecentProjects(projectIds: number[]) {
  const { results } = await API.UnisonProjects.fetchUnisonProjects({
    pagination: { page: 1, pageSize: RECENT_LIMIT },
    filters: [
      {
        filterType: FILTER_TYPES.COLUMN_VALUE,
        column: 'id',
        comparisonOperator: COMPARISON_OPERATORS.IN.value,
        value: projectIds,
      },
    ],
  });
  if (!results) return [];
  // Preserve the original recents order (most-recent first)
  return results.sort(
    (a, b) => projectIds.indexOf(a.id) - projectIds.indexOf(b.id)
  );
}
